import { getLinkToMobileApp } from './getLinkToMobileApp';

export const redirectToMobileApp = (appLink = 'karma://') => {
  let hasRedirected = false;

  // Handle visibility change
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && !hasRedirected) {
      hasRedirected = true;
      window.location.href = getLinkToMobileApp();
    }
  });

  // Fallback timer
  setTimeout(() => {
    if (!hasRedirected) {
      hasRedirected = true;
      window.location.href = getLinkToMobileApp();
    }
  }, 5000);

  window.location.href = appLink;
};
